import {Box, BoxProps, styled} from '@mui/material';

export type ColorLabelProps = BoxProps;

// Built with `styled` rather than a plain wrapper so that the ref reaches
// the DOM node — a Tooltip cannot anchor to a component without a ref
export const ColorLabel = styled(Box)(({theme}) => ({
  padding: theme.spacing(0.75),
  borderRadius: '5px',
})) as typeof Box;
